import { EnrollmentLight } from '../../lib/types/models/enrollment/enrollment-light'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getSimilarEnrollments(id: number): Promise<EnrollmentLight[]> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getSimilarEnrollments.url, { id }))
    .get<EnrollmentLight[]>()
}
